<item-full-modal
    modalTitle="{{ (editable.id ? l10nKeys.modalHeaderEdit : l10nKeys.modalHeaderNew) | vtranslate : editable.getName() }}"
    [form]="form"
    [item]="editable"
    modalClassName="alert-config-modal"
>
    <form
        clrForm
        #form="ngForm"
        [clrLayout]="verticalLayout"
        [invalidateForm]="isFormInvalid"    
    >
        <full-modal-tab-section tabTitle="{{ globalL10nKeys.generalLabel | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ globalL10nKeys.generalLabel | vtranslate }}</h3>
                <avi-input-container>
                    <label
                        aviLabelWithTooltip
                        fieldName="name"
                        for="name"
                        objectType="{{ objectType }}"
                        required
                    >
                        {{ globalL10nKeys.nameLabel | vtranslate }}
                    </label>
                    <input
                        [(ngModel)]="editable.config.name"
                        clrInput
                        fieldName="name"
                        id="name"
                        name="name"
                        placeholder="{{ globalL10nKeys.namePlaceholder | vtranslate }}"
                        required
                    />
                </avi-input-container>
                <avi-checkbox
                    name="enableAlertTrigger"
                    [(ngModel)]="editable.config.enabled"
                >
                    {{ l10nKeys.enableAlertTriggerLabel | vtranslate }}
                </avi-checkbox>
                <avi-textarea-container>
                    <label
                        aviLabelWithTooltip
                        objectType="{{ objectType }}"
                        fieldName="description"
                        for="description"
                    >
                        {{ globalL10nKeys.descriptionLabel | vtranslate }}
                    </label>
                    <textarea
                        clrTextarea
                        id="description"
                        [(ngModel)]="editable.config.description"
                        name="description"
                        placeholder="{{ globalL10nKeys.descriptionPlaceholder | vtranslate }}"
                    ></textarea>
                </avi-textarea-container>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            objectType="{{ objectType }}"
                            fieldName="source"
                            for="source"
                        >
                            {{ l10nKeys.sourceInputLabel | vtranslate }}
                        </label>
                        <avi-enum-dropdown
                            name="source"
                            id="source"
                            [(ngModel)]="editable.config.source"
                            (ngModelChange)="handleSourceChange()"
                            enum="AlertSource"
                            [hiddenEnumValues]="hiddenAlertSourceValues"
                            required
                        ></avi-enum-dropdown>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>
        <full-modal-tab-section tabTitle="{{ l10nKeys.conditionsHeader | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.conditionsHeader | vtranslate }}</h3>
                <avi-input-container>
                    <label
                        aviLabelWithTooltip
                        fieldName="throttle"
                        objectType="{{ objectType }}"
                        for="throttle"
                        required
                    >
                        {{ l10nKeys.throttleAlertInputLabel | vtranslate }}
                    </label>
                    <input
                        fieldName="throttle"
                        objectType="{{ objectType }}"
                        name="throttle"
                        [(ngModel)]="editable.config.throttle"
                        clrInput
                        id="throttle"
                        configFieldInputValidation
                        type="number"
                        required
                    />
                </avi-input-container>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <avi-fieldset>
                            <avi-fieldset_header class="alert-config-modal__object-dropdown">
                                <label
                                    aviLabelWithTooltip
                                    fieldName="object_type"
                                    objectType="{{ objectType }}"
                                    for="object-type"
                                >
                                    {{ l10nKeys.objectInputLabel | vtranslate }}
                                </label>
                                <avi-dropdown
                                    id="object-type"
                                    name="object-type"
                                    [options]="objectTypeDropdownOptions"
                                    [(ngModel)]="objType"
                                    (ngModelChange)="handleObjectTypeChange()"
                                    placeholder="{{ l10nKeys.objectInputLabel | vtranslate }}"
                                ></avi-dropdown>
                            </avi-fieldset_header>

                            <avi-fieldset_content>
                                <div
                                    *ngIf="editable.config.object_type"
                                    class="full-modal-config__form-control-row alert-config-modal__no-margin-top"
                                >
                                    <div class="full-modal-config__form-control">
                                        <label
                                            aviLabelWithTooltip
                                            fieldName="obj_uuid"
                                            objectType="{{ objectType }}"
                                            for="threshold"
                                        >
                                            {{ l10nKeys.instanceInputLabel | vtranslate }}
                                        </label>
                                        <avi-collection-dropdown
                                            name="obj-ref"
                                            [placeholder]="objDropdownPlaceholder"
                                            [(ngModel)]="editable.config.obj_ref"
                                            [collection]="currentOption?.collection"
                                            [disableCreate]="isGslbServiceCreateDisabled"
                                            [required]="objRequired"
                                        ></avi-collection-dropdown>
                                    </div>
                                </div>

                                <avi-input-container [noMarginTop]="!editable.config.object_type">
                                    <label
                                        aviLabelWithTooltip
                                        fieldName="threshold"
                                        objectType="{{ objectType }}"
                                        for="threshold"
                                    >
                                        {{ l10nKeys.numberOfOccurrencesInputLabel | vtranslate }}
                                    </label>
                                    <input
                                        fieldName="threshold"
                                        objectType="{{ objectType }}"
                                        name="threshold"
                                        type="number"
                                        clrInput
                                        id="threshold"
                                        configFieldInputValidation
                                        [(ngModel)]="editable.config.threshold"
                                    />
                                </avi-input-container>
                                <enum-radio-buttons
                                    name="category"
                                    [(ngModel)]="editable.config.category"
                                    enum="AlertCategory"
                                    [hiddenEnumValues]="hiddenAlertCategoryValues"
                                >
                                    <label
                                        aviLabelWithTooltip
                                        fieldName="category"
                                        objectType="{{ objectType }}"
                                    >
                                        {{ l10nKeys.categoryInputLabel | vtranslate }}
                                    </label>
                                </enum-radio-buttons>
                                <avi-input-container *ngIf="editable.config.category === alertCategoryHash.ROLLINGWINDOW">
                                    <label
                                        aviLabelWithTooltip
                                        fieldName="rolling_window"
                                        objectType="{{ objectType }}"
                                        for="rolling-window"
                                    >
                                        {{ l10nKeys.timeWindowInputLabel | vtranslate }}
                                    </label>
                                    <input
                                        fieldName="rolling_window"
                                        objectType="{{ objectType }}"
                                        name="rolling-window"
                                        type="number"
                                        clrInput
                                        configFieldInputValidation
                                        [(ngModel)]="editable.config.rolling_window"
                                    />
                                </avi-input-container>

                                <ng-container *ngIf="source === 'METRICS'">
                                    <label
                                        aviLabelWithTooltip
                                        class="alert-config-modal__label"
                                        required
                                    >
                                        {{ l10nKeys.metricsLabelWithCount | vtranslate : editable.metricRules.count }}
                                    </label>
                                    <avi-data-grid
                                        [config]="metricsGridConfig"
                                        [rows]="editable.metricRules.config"
                                        class="alert-config-modal__avi-data-grid"
                                    >
                                        <avi-data-grid_actions>
                                            <cds-button
                                                (click)="editable.addMetricRow()"
                                                size="sm"
                                            >
                                                {{ globalL10nKeys.addLabel | vtranslate }}
                                            </cds-button>
                                        </avi-data-grid_actions>
                                    </avi-data-grid>
                                </ng-container>
                                <div *ngIf="source === 'EVENT_LOGS'">
                                    <label
                                        aviLabelWithTooltip
                                        class="alert-config-modal__label"
                                        required
                                    >
                                        {{ l10nKeys.eventsLabelWithCountLabel | vtranslate : editable.sysEventRules.count }}
                                    </label>
                                    <avi-data-grid
                                        [config]="eventsLogGridConfig"
                                        [rows]="editable.sysEventRules.config"
                                        class="alert-config-modal__avi-data-grid"
                                    >
                                        <avi-data-grid_actions>
                                            <cds-button
                                                (click)="editable.addEventRow()"
                                                size="sm"
                                            >
                                                {{ globalL10nKeys.addLabel | vtranslate }}
                                            </cds-button>
                                        </avi-data-grid_actions>
                                    </avi-data-grid>
                                </div>

                                <div *ngIf="showMultipleOperators">
                                    <avi-radio-container>
                                        <label
                                            aviLabelWithTooltip
                                            for="multiple-events"
                                        >
                                            {{ l10nKeys.multipleEventsOperatorLabel | vtranslate }}
                                        </label>
                                        <avi-radio
                                            name="multiple-events"
                                            [(ngModel)]="editable.alertRuleConfig.operator"
                                            [value]="alertRuleOperatorEnumHash.OPERATOR_AND"
                                        >
                                            {{ l10nKeys.andRadioOption | vtranslate }}
                                        </avi-radio>
                                        <avi-radio
                                            name="multiple-events"
                                            [(ngModel)]="editable.alertRuleConfig.operator"
                                            [value]="alertRuleOperatorEnumHash.OPERATOR_OR"
                                        >
                                            {{ l10nKeys.orRadioOption | vtranslate }}
                                        </avi-radio>
                                        <avi-radio
                                            name="multiple-events"
                                            [(ngModel)]="editable.alertRuleConfig.operator"
                                            [value]="alertRuleOperatorEnumHash.OPERATOR_NOT"
                                        >
                                            {{ l10nKeys.andNotRadioOption | vtranslate }}
                                        </avi-radio>
                                    </avi-radio-container>
                                </div>

                                <avi-checkbox
                                    name="autoscale-alert"
                                    fieldName="autoscale_alert"
                                    objectType="{{ objectType }}"
                                    [(ngModel)]="editable.config.autoscale_alert"
                                >
                                    {{ l10nKeys.autoScaleAlertInputLabel | vtranslate }}
                                </avi-checkbox>
                            </avi-fieldset_content>
                        </avi-fieldset>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>

        <full-modal-tab-section tabTitle="{{ l10nKeys.actionsHeader | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.actionsHeader | vtranslate }}</h3>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            objectType="{{ objectType }}"
                            fieldName="action_group_uuid"
                            for="action_group"
                            required
                        >
                            {{ l10nKeys.alertActionInputLabel | vtranslate }}
                        </label>
                        <avi-collection-dropdown
                            [collection]="actionGroupConfigCollection"
                            [(ngModel)]="editable.config.action_group_ref"
                            name="action_group"
                            id="action_group"
                            required
                        ></avi-collection-dropdown>
                    </div>
                </div>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <avi-input-container>
                            <label
                                aviLabelWithTooltip
                                fieldName="expiry_time"
                                for="expiry-time"
                                objectType="{{ objectType }}"
                            >
                                {{ l10nKeys.alertExpiryTimeInputLabel | vtranslate }}
                            </label>
                            <input
                                fieldName="expiry_time"
                                objectType="{{ objectType }}"
                                name="expiry-time"
                                [(ngModel)]="editable.config.expiry_time"
                                clrInput
                                configFieldInputValidation
                            />
                        </avi-input-container>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>
        <ng-template
            #eventOccursFieldTemplateRef
            let-row
            let-index="index"
        >
            <avi-enum-dropdown
                name="{{ 'event-id-' + index }}"
                id="{{ 'event-id-' + index }}"
                [(ngModel)]="row.config.event_id"
                enum="EventId"
                required
            ></avi-enum-dropdown>
        </ng-template>
    </form>
</item-full-modal>

<ng-template
    #metricFieldTemplateRef
    let-row
    let-index="index"
>
    <avi-input-container noMarginTop>
        <avi-collection-dropdown
            name="metric-occurs"
            placeholder="{{ l10nKeys.selectMetricRuleLabel | vtranslate }}"
            [(ngModel)]="row.config.metric_id"
            [collection]="alertMetricsCollection"
            required
        ></avi-collection-dropdown>
    </avi-input-container>
</ng-template>

<ng-template
    #comparatorFieldTemplateRef
    let-row
    let-index="index"
>
    <avi-enum-dropdown
        name="comparator"
        [(ngModel)]="row.config.metric_threshold.config.comparator"
        enum="AlertOperation"
        required
    ></avi-enum-dropdown>
</ng-template>

<ng-template
    #durationFieldTemplateRef
    let-row
    let-index="index"
>
    <avi-input-container noMarginTop>
        <input
            clrInput
            configFieldInputValidation
            name="duration"
            fieldName="duration"
            objectType="{{ alertRuleMetric }}"
            placeholder="{{ l10nKeys.durationInputLabel | vtranslate }}"
            [(ngModel)]="row.config.duration"
            type="number"
            required
        />
    </avi-input-container>
</ng-template>

<ng-template
    #valueUnitsFieldTemplateRef
    let-row
    let-index="index"
>
    <avi-input-container noMarginTop>
        <input
            clrInput
            configFieldInputValidation
            fieldName="threshold"
            name="threshold"
            placeholder="{{ l10nKeys.enterThresholdLabel | vtranslate }}"
            [(ngModel)]="row.config.metric_threshold.config.threshold"
            objectType="{{ alertMetricThreshold }}"
            required
            type="number"
        />
    </avi-input-container>
</ng-template>
